export default "__VITE_ASSET__BFWnmoXy__"